import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import "./Card.css";
const Card = () => {
  const [open, setOpen] = useState("team");

  const handleTabOpen = (tabCategory) => {
    setOpen(tabCategory);
  };

  const getTabContent = (tab) => {
    switch (tab) {
      case "home":
        return {
          img: "https://res.cloudinary.com/dbitupkaa/image/upload/v1747381116/kikik-CAhfKUSF_bxmfpe.png",
          title: "Transform Your Business with Microsoft Azure",
          description:
            "Our team of certified Azure professionals is ready to help you leverage the full power of Microsoft's cloud platform. From scalable storage solutions to advanced analytics, we offer comprehensive support to ensure your business thrives in the cloud.",
          services: [
            "Azure Synapse",
            "Azure AVD",
            "Azure IoT",
            "Azure DevOps",
            "Azure AI & Ml",
            "Data Warehousing",
            "Migration",
            "Azure Identity",
            "Azure Govt.",
            "Azure Database",
            "Azure Container",
            "Azure Mixed Reality",
          ],
          link: "https://teams.microsoft.com",
          buttonText: "Read More",
        };
      case "about":
        return {
          img: "https://res.cloudinary.com/dbitupkaa/image/upload/v1747381051/gt-CG8HTwhf_x2zobi.png",
          title: "Optimize Your Workflow with Microsoft 365  ",
          description:
            "Streamline your operations and enhance productivity with our skilled Microsoft 365 experts. We provide tailored solutions for email, collaboration, and document management, ensuring seamless integration across your organization.",
          services: [
            "MIP",
            " ATP ",
            "Cloud App Security",
            "Defender for Endpoint",
            "Defender for Identity",
            " Intune",
            " Casby",
            "Compliance Manager ",
            " PIM",
            "DLP",
            "Azure AD",
          ],
          link: "https://example.com",
          buttonText: "Read More",
        };
      case "team":
        return {
          img: "https://res.cloudinary.com/dbitupkaa/image/upload/v1747380999/copilotImg-DMPVn_0O_epqxwp.png",
          title: "Enhance Your Productivity with Microsoft Copilot  ",
          description:
            "Unlock the potential of AI-assisted workflows with Microsoft Copilot. Our experienced professionals can help you integrate and maximize Copilot's capabilities, driving efficiency and innovation in your daily tasks.",
          services: [
            "Copilot for Teams",
            "Copilot For Outlook",
            "Copilot For Security",
            "Copilot For Excel",
            "Copilot For App",
          ],
          link: "https://example.com",
          buttonText: "Read More",
        };
      case "service":
        return {
          img: "https://res.cloudinary.com/dbitupkaa/image/upload/v1747381156/dyOne-Du_nU2t6_v9rech.png",
          title: "Revolutionize Your Operations with Microsoft Dynamics 365",
          description:
            "Our Dynamics 365 specialists are equipped to optimize your business processes, from customer relationship management to enterprise resource planning. Enhance your operational efficiency with our expert support. Hire our skilled professionals today.",
          services: [
            "Business Central",
            "HR",
            "Field Service",
            "Sales",
            "Finance and Operations",
            "Marketing",
          ],
          link: "https://example.com",
          buttonText: "Read More",
        };
      case "blog":
        return {
          img: "https://res.cloudinary.com/dbitupkaa/image/upload/v1747381203/powerImg-BrIVGfZG_bsdqwf.png",
          title: "Empower Your Business with Microsoft Power Platform",
          description:
            "Harness the full potential of low-code development, analytics, and automation with our Microsoft Power Platform experts. We provide resources skilled in Power BI, Power Apps, Power Automate, and Power Virtual Agents, ready to drive your digital transformation.",
          services: [
            "Power Automate",
            "Power Apps",
            "Power Virtual Agents",
            "Power Virtual Agents",
            "Power Virtual Agents",
          ],
          link: "https://example.com",
          buttonText: "Read More",
        };

      default:
        return {};
    }
  };

  const tabContent = getTabContent(open);

  return (
    <>
      <div className="bg-gray-50 font-Questrial ">
        <div className="max-w-5xl mx-auto">
        <div className="text-center px-4 lg:px-6 py-8 md:py-16 font-Calistoga ">
          <h2 className="heading-animation text-3xl lg:text-[30px] font-medium mb-2 mt-6 leading-relaxed text-slate-600">
            Maximize Impact. <br />{" "}
            <span class="bg-gradient-to-r from-[#414de1] to-[#b241e1] bg-clip-text text-transparent scroll-my-2">
              Transform, Scale, Optimize <br />
            </span>{" "}
            Seamlessly With Certified Technical Experts.
          </h2>
        </div>
        <section className="py-8 dark:bg-dark lg:py-8 px-4 lg:px-6 ">
          <div className="container">
            <div className="mx-auto max-w-6xl">
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
                <CardButton
                  onClick={() => handleTabOpen("team")}
                  title="Microsoft Copilot"
                  active={open === "team"}
                />
                <CardButton
                  onClick={() => handleTabOpen("about")}
                  title="Microsoft 365"
                  active={open === "about"}
                />
                <CardButton
                  onClick={() => handleTabOpen("home")}
                  title="Microsoft Azure"
                  active={open === "home"}
                />
                <CardButton
                  onClick={() => handleTabOpen("service")}
                  title="Microsoft Dynamics 365"
                  active={open === "service"}
                />
                <CardButton
                  onClick={() => handleTabOpen("blog")}
                  title="Microsoft Power Platform"
                  active={open === "blog"}
                />
              </div>

              <div className="mt-8 ">
                <TabContent
                  img={tabContent.img}
                  title={tabContent.title}
                  description={tabContent.description}
                  link={tabContent.link}
                  buttonText={tabContent.buttonText}
                  services={tabContent.services}
                />
              </div>
            </div>
          </div>
        </section>
        </div>
      </div>
    </>
  );
};


const CardButton = ({ onClick, title, active }) => {
  return (
    <button
      onClick={onClick}
      className={`relative bg-white flex items-center justify-center w-full rounded-lg p-2 text-sm font-medium transform transition-all duration-300 shadow-md ${
        active
          ? "text-blue-700 scale-105 after:content-[''] after:block after:w-full after:h-1 after:bg-blue-700 after:rounded after:absolute after:bottom-0 after:left-0"
          : "text-[#3b3c4f] hover:text-blue-700 hover:after:content-[''] hover:after:block hover:after:w-full hover:after:h-1 hover:after:bg-blue-700 hover:after:rounded hover:after:absolute hover:after:bottom-0 hover:after:left-0"
      }`}
    >
      <div className="absolute top-0 left-0 w-full h-full rounded-lg opacity-0 hover:opacity-100 z-0 transition-opacity duration-300"></div>
      <div className="z-10 relative flex items-center">{title}</div>
    </button>
  );
};

const TabContent = ({
  img,
  title,
  description,
  link,
  buttonText,
  services,
}) => {
  const [showImage, setShowImage] = useState(false);
  console.log("Services:", services);

  const handleImageClick = () => {
    setShowImage(!showImage);
  };

  return (
    
    <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4 rounded-2xl text-sm leading-relaxed text-body-color transition-all duration-300">
      <div className="p-2 md:p-4">
        <h2 className="text-lg md:text-2xl font-semibold mb-2">{title}</h2>
        <p className="text-sm md:text-base mb-3">{description}</p>

        <div className="flex flex-wrap gap-2 mb-3">
          {services?.map((service, index) => (
            <div
              key={index}
              className="bg-white p-1 md:p-2 rounded shadow text-xs"
            >
              {service}
            </div>
          ))}
        </div>

        {/* <div className="mt-4">
          <Link
            to={link}
            target="_blank"
            className="text-blue-700 text-sm inline-flex items-center"
          >
            {buttonText}
            <FaArrowRight className="ml-2" />
          </Link>
        </div> */}
      </div>

      <div className="flex justify-center items-center">
        <img
          src={img}
          alt={title}
          className="w-full max-w-xs md:max-w-sm h-auto rounded-2xl shadow-lg transition duration-300"
        />
      </div>
    </div>
  );
};

export default Card;
